import HeroBanner from "./HeroBanner";
import PageHeroBanner from "./PageHeroBanner";

export default HeroBanner;
export { PageHeroBanner };
